import * as go from 'gojs';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { ModelDataHighlight } from 'src/containers/ProjectDiagram/constants/highlight';
import {
  Diagram,
  ModelConceptRelationshipLink,
} from 'src/containers/ProjectDiagram/types/diagram';
import { ModelDataHighlighted } from 'src/containers/ProjectDiagram/types/model';
import { isLink } from 'src/containers/ProjectDiagram/utils/graphObject';

const attachmentProperties = {
  [ModelDataHighlight.LINK_HEAD]: 'relinkableTo' as const,
  [ModelDataHighlight.LINK_TAIL]: 'relinkableFrom' as const,
};

const getIsDetachableLinkEndConverter = (
  modelHighlightType: ModelDataHighlight
) => {
  function forModelHighlighted(
    modelHighlighted: ModelDataHighlighted | null,
    { part }: go.Shape
  ) {
    if (
      !modelHighlighted ||
      !part ||
      !isLink<ModelConceptRelationshipLink>(
        part,
        LinkCategory.MODEL_CONCEPT_RELATIONSHIP
      )
    ) {
      return false;
    }

    const isEndHighlighted =
      modelHighlighted.type === modelHighlightType &&
      modelHighlighted.key === part.data.key;
    const isEndAttached = !part[attachmentProperties[modelHighlightType]];

    return isEndHighlighted && isEndAttached;
  }

  function forObjectEndNode(endNode: go.Node | null, { part }: go.Shape) {
    if (
      !endNode ||
      !part ||
      !isLink<ModelConceptRelationshipLink>(
        part,
        LinkCategory.MODEL_CONCEPT_RELATIONSHIP
      ) ||
      !part.diagram
    ) {
      return false;
    }

    const diagram = part.diagram as Diagram;
    const { highlighted } = diagram.model.modelData;
    const isEndHighlighted = Boolean(
      highlighted &&
        highlighted.type === modelHighlightType &&
        highlighted.key === part.data.key
    );

    return isEndHighlighted;
  }

  return {
    forModelHighlighted,
    forObjectEndNode,
  };
};

export const isDetachableLinkHeadConverter = getIsDetachableLinkEndConverter(
  ModelDataHighlight.LINK_HEAD
);

export const isDetachableLinkTailConverter = getIsDetachableLinkEndConverter(
  ModelDataHighlight.LINK_TAIL
);
